import { render, staticRenderFns } from "./handle-class-detail.vue?vue&type=template&id=40f593d4&"
import script from "./handle-class-detail.vue?vue&type=script&lang=js&"
export * from "./handle-class-detail.vue?vue&type=script&lang=js&"
import style0 from "./handle-class-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports